var portfolioPositionsWeight = {
	caption: "Ponderazione posizioni di portfafoglio",
	label: {
		name: "Nome",
		isin: "ISIN",
		marketValue: "Valore di mercato",
		weight: "Ponderzione %",
		weightBar: "Ponderzione % di max"
	},
	noPositions: "Nessun risultato trovato"
};
var it = {
	portfolioPositionsWeight: portfolioPositionsWeight
};

export { it as default, portfolioPositionsWeight };
